import React from "react";

const Privacy = () => {
  return (
    <div>
      {/* Minimal Header */}
      <div className="bg-slate-900 text-white py-12 md:py-16 text-center">
        <h1 className="text-2xl md:text-4xl font-extralight tracking-widest uppercase text-slate-100">
          Privacy Policy
        </h1>
        <div className="w-16 h-0.5 bg-blue-500 mx-auto mt-3 mb-3"></div>
        <p className="text-slate-400 text-xs md:text-sm max-w-xl mx-auto px-4 font-light leading-relaxed">
          Our commitment to protecting your privacy and security.
        </p>
      </div>
      <div className="text-center w-[60%] m-auto py-3  font-teko my-10">
        <h5 className="text-blue-600 text-1xl font-[700] ">Privacy & Policy</h5>
      </div>
      <div className="w-[90%] m-auto py-3 text-justify font-teko">
        <ul class="list-disc list-inside mb-4 text-gray-600">
          <li>
            HMT Technical Services built the HMT Technical website as a Commercial website.
            This SERVICE is provided by HMT Technical Services and is intended
            for use as is.
          </li>
          <li>
            This page is used to inform visitors regarding our policies with the
            collection, use, and disclosure of Personal Information if anyone
            decided to use our Service.
          </li>
          <li>
            If you choose to use our Service, then you agree to the collection
            and use of information in relation to this policy. The Personal
            Information that we collect is used for providing and improving the
            Service. We will not use or share your information with anyone
            except as described in this Privacy Policy.
          </li>
          <li>
            The terms used in this Privacy Policy have the same meanings as in
            our Terms and Conditions, which are accessible at HMT Technical Services unless
            otherwise defined in this Privacy Policy.
          </li>
        </ul>
        <h5 class="text-xl font-bold my-2">Information Collection and Use</h5>
        <ul class="list-disc list-inside mb-4 text-gray-600">
          <li>
            For a better experience, while using our Service, we may require you
            to provide us with certain personally identifiable information,
            including but not limited to HMT Technical Services. The
            information that we request will be retained by us and used as
            described in this privacy policy.
          </li>
          <li>
            The app does use third-party services that may collect information
            used to identify you.
          </li>
          <li>
            Link to the privacy policy of third-party service providers used by
            the app&nbsp;
            <a
              href="https://policies.google.com/privacy"
              class="text-blue-600 hover:underline"
            >
              Google Play Services
            </a>
          </li>
        </ul>
        <h5 class="text-xl font-bold my-2">Log Data</h5>
        <p class="mb-4 text-gray-600">
          We want to inform you that whenever you use our Service, in a case of
          an error in the app we collect data and information (through
          third-party products) on your phone called Log Data. This Log Data may
          include information such as your device Internet Protocol (“IP”)
          address, device name, operating system version, the configuration of
          the app when utilizing our Service, the time and date of your use of
          the Service, and other statistics.
        </p>
        <h5 class="text-xl font-bold my-2">Cookies</h5>
        <p class="mb-4 text-gray-600">
          Cookies are files with a small amount of data that are commonly used
          as anonymous unique identifiers. These are sent to your browser from
          the websites that you visit and are stored on your device's internal
          memory.
          <br />
          <br />
          This Service does not use these “cookies” explicitly. However, the app
          may use third-party code and libraries that use “cookies” to collect
          information and improve their services. You have the option to either
          accept or refuse these cookies and know when a cookie is being sent to
          your device. If you choose to refuse our cookies, you may not be able
          to use some portions of this Service.
        </p>
        <h5 class="text-xl font-bold my-2">Service Providers</h5>
        <p class="mb-4 text-gray-600">
          We may employ third-party companies and individuals due to the
          following reasons:
        </p>
        <ul class="list-disc list-inside mb-4 text-gray-600">
          <li>To facilitate our Service;</li>
          <li>To provide the Service on our behalf;</li>
          <li>To perform Service-related services; or</li>
          <li>To assist us in analyzing how our Service is used.</li>
        </ul>
        <p className="text-gray-600">
          We want to inform users of this Service that these third parties have
          access to their Personal Information. The reason is to perform the
          tasks assigned to them on our behalf. However, they are obligated not
          to disclose or use the information for any other purpose.
        </p>
        <h5 class="text-xl font-bold my-2">Security</h5>
        <p class="mb-4 text-gray-600">
          We value your trust in providing us your Personal Information, thus we
          are striving to use commercially acceptable means of protecting it.
          But remember that no method of transmission over the internet, or
          method of electronic storage is 100% secure and reliable, and we
          cannot guarantee its absolute security.
        </p>
        <h5 class="text-xl font-bold my-2">Links to Other Sites</h5>
        <p class="mb-4 text-gray-600">
          This Service may contain links to other sites. If you click on a
          third-party link, you will be directed to that site. Note that these
          external sites are not operated by us. Therefore, we strongly advise
          you to review the Privacy Policy of these websites. We have no control
          over and assume no responsibility for the content, privacy policies,
          or practices of any third-party sites or services.
        </p>
        <h5 class="text-xl font-bold my-2">Children’s Privacy</h5>
        <p class="mb-4 text-gray-600">
          These Services do not address anyone under the age of 13. We do not
          knowingly collect personally identifiable information from children
          under 13 years of age. In the case we discover that a child under 13
          has provided us with personal information, we immediately delete this
          from our servers. If you are a parent or guardian and you are aware
          that your child has provided us with personal information, please
          contact us so that we will be able to do the necessary actions.
        </p>
      </div>
      <div className="text-center w-[60%] m-auto py-3  font-teko my-10">
        <h5 className="text-blue-600 text-1xl font-[700] ">
          Terms & Conditions
        </h5>
      </div>
      <div className="w-[90%] m-auto py-3 text-justify font-teko">
        <p className="mb-4 text-gray-600">
          By downloading or using the app, these terms will automatically apply
          to you – you should make sure therefore that you read them carefully
          before using the app. You’re not allowed to copy or modify the app,
          any part of the app, or our trademarks in any way. You’re not allowed
          to attempt to extract the source code of the app, and you also
          shouldn’t try to translate the website into other languages or make
          derivative versions. The website itself, and all the trademarks,
          copyright, database rights, and other intellectual property rights
          related to it, still belong to HMT Technical Services.
        </p>
        <p className="mb-4 text-gray-600">
          HMT Technical Services is committed to ensuring that the website is as
          useful and efficient as possible. For that reason, we reserve the
          right to make changes to the website or to charge for its services, at any
          time and for any reason. We will never charge you for the website or its
          services without making it very clear to you exactly what you’re
          paying for.
        </p>
        <p className="mb-4 text-gray-600">
          The HMT Technical website stores and processes personal data that you have
          provided to us, to provide our Service. It’s your responsibility to
          keep your computer or mobile device and access to the website secure. We therefore recommend
          that you do not jailbreak or root your device, which is the process of
          removing software restrictions and limitations imposed by the official
          operating system of your device. It could make your device vulnerable
          to malware/viruses/malicious programs, compromise your device’s
          security features and it could mean that the website won’t work
          properly or at all.
        </p>
        <p className="mb-4 text-gray-600">
          The website does use third-party services that declare their Terms and
          Conditions.&nbsp;
          <a
            href="https://policies.google.com/privacy"
            class="text-blue-600 hover:underline"
          >
            Google Play Services
          </a>
        </p>
        <p className="mb-4 text-gray-600">
          You should be aware that there are certain things that HMT Technical Services
          will not take responsibility for. Certain functions of the
          website will require the website to have an active internet connection. The
          connection can be Wi-Fi or provided by your mobile network provider,
          but HMT Technical Services cannot take responsibility for the website
          not working at full functionality if you don’t have access to Wi-Fi,
          and you don’t have any of your data allowance left.
        </p>
        <p className="mb-4 text-gray-600">
          If you’re using the app outside of an area with Wi-Fi, you should
          remember that the terms of the agreement with your mobile network
          provider will still apply. As a result, you may be charged by your
          mobile provider for the cost of data for the duration of the
          connection while accessing the app, or other third-party charges. In
          using the app, you’re accepting responsibility for any such charges,
          including roaming data charges if you use the app outside of your home
          territory (i.e. region or country) without turning off data roaming.
          If you are not the bill payer for the device on which you’re using the
          app, please be aware that we assume that you have received permission
          from the bill payer for using the app.
        </p>
        <p className="mb-4 text-gray-600">
          Along the same lines, HMT Technical Services cannot always take
          responsibility for the way you use the website i.e. You need to make sure
          that your device stays charged – if it runs out of battery and you
          can’t turn it on to avail the Service, HMT Technical Services cannot
          accept responsibility.
        </p>
        <p className="mb-4 text-gray-600">
          With respect to HMT Technical Services’s responsibility for your use
          of the website, when you’re using the website, it’s important to bear in mind
          that although we endeavor to ensure that it is updated and correct at
          all times, we do rely on third parties to provide information to us so
          that we can make it available to you. HMT Technical Services accepts
          no liability for any loss, direct or indirect, you experience as a
          result of relying wholly on this functionality of the website.
        </p>
        <p className="mb-4 text-gray-600">
          At some point, we may wish to update the website. The website is currently
          available on browsers – the requirements for the system(and for any
          additional systems we decide to extend the availability of the website to)
          may change, and you’ll need to download or refresh the browser to update. HMT Technical Services does not promise that it
          will always update the website so that it is relevant to you and/or works
          with the browser version that you have installed on your device.
          However, you promise to always accept updates to the application when
          offered to you, We may also wish to stop providing the website, and may
          terminate use of it at any time without giving notice of termination
          to you. Unless we tell you otherwise, upon any termination, (a) the
          rights and licenses granted to you in these terms will end; (b) you
          must stop using the website.
        </p>
        <h5 class="text-xl font-bold my-2">Changes to This Privacy Policy</h5>
        <p class="mb-4 text-gray-600">
          We may update our Privacy Policy from time to time. Thus, you are
          advised to review this page periodically for any changes. We will
          notify you of any changes by posting the new Privacy Policy on this
          page.
        </p>
        <p className="text-gray-600 mb-4">
          This policy is effective as of 2024-02-26
        </p>
        <h5 class="text-xl font-bold my-2">Contact Us</h5>
        <p class="mb-4 text-gray-600">
          If you have any questions or suggestions about our Privacy Policy, do
          not hesitate to contact us at{" "}
          <a
            href="mailto:hmttechnical16@gmail.com"
            class="text-blue-600 hover:underline"
          >
            hmttechnical16@gmail.com.
          </a>
        </p>
      </div>
    </div>
  );
};

export default Privacy;
